

























import {Component} from 'vue-property-decorator';
import BaseSelect from '@/utils/BaseSelect';

@Component({
  inheritAttrs: false,
})
export default class SelectField extends BaseSelect {}
